//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "chaosong-popup-view",
    props: {
        value: {
            type: Boolean,
            default: false
        },
        organizationId: {
            type: Number,
            required: true,
        },
        workOrderId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            saveForm: {
                content: ''
            },
            saving: false,
            departments: [],
            departmentUser: [],
            showDispachist: false,
            showDepartmentUser: false,
        }
    },
    methods: {
        getDepartments() {
            if (this.organizationId === 0) {
                // this.$toast.fail("项目没有绑定组织结构")
                return;
            }
            abp.ajax.get('/api/services/app/OrganizationUnit/GetDepartmentsByParentId?parentId=' + this.organizationId).then(res => {
                this.departments = [];
                this.departments = res.data.result;

            }).finally(() => {
            });
        },
        getDepartmentUser(organizationId) {
            if (this.organizationId === 0) {
                // this.$toast.fail("项目没有绑定组织结构")
                return;
            }
            abp.ajax.get('/api/services/app/OrganizationUnit/GetDepartmentUser?organizationId=' + organizationId).then(res => {
                this.departmentUser = [];
                this.departmentUser = res.data.result;
                this.departmentUser.forEach(item => {
                    item.text = item.name;
                })
            }).finally(() => {
            });
        },
        onPaidanDepartmentConfirm(val) {
            console.log(val)
            this.saveForm.departmentId = val.id;
            this.saveForm.departmentName = val.name;
            this.saveForm.userId = 0;
            this.departmentUser = [];
            this.getDepartmentUser(val.id);
            this.showDispachist = false;
        },
        onPaidanUserConfirm(val) {
            this.saveForm.userId = val.id;
            this.saveForm.name = val.name;
            this.showDepartmentUser = false;
        },
        cancel() {
            this.saveForm = {};
            this.$emit('cancel', false)
        },
        onSave() {
            console.log(this.saveForm)
            this.saveForm.workOrderId = this.workOrderId;
            this.saving = true;
            abp.ajax.post('/api/services/app/WorkOrder/MChaoSong', this.saveForm).then(res => {

                this.cancel()

            }).finally(() => {
                this.saving = false;
            })
        },

    },
    created() {
        if (this.organizationId > 0) {
            this.getDepartments()
        }

    },
    watch: {
        organizationId() {
            if (this.organizationId > 0) {
                this.getDepartments()
            }
        }
    }
}
